import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomTextArea, CustomTextAreaProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomTextAreaWrapperProps = WithInput<CustomTextAreaProps>;

const CustomTextAreaWrapper: React.FC<CustomTextAreaWrapperProps> = (props: CustomTextAreaWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomTextArea
            containerStyle={containerStyle}
            getContainerRef={setContainerRef}
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomTextAreaWrapper);
